import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { breakpoints, colors, spacing, fonts, fontSize } = redesignTheme;

export const useMediaPanelStyles = makeStyles(() => ({
  mediaPanel: {
    position: 'relative',
    flex: 1,
    overflow: 'hidden',
    minHeight: 467,
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      maxWidth: '50%',
      height: '100vh',
      minHeight: 'auto',
    },
  },
  video: {
    zIndex: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  videoOverlay: {
    width: '100%',
    height: '100%',
    background: colors.overlay,
    opacity: 0.4,
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
  },
  mediaContent: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing.sm,
    boxSizing: 'border-box' as const,
    textAlign: 'center',
    [`@media (max-width: ${breakpoints.desktop - 1}px)`]: {
      padding: spacing.md,
    },
  },
  mediaTitle: {
    color: colors.white,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.lg,
    textAlign: 'center',
    marginBottom: 10,
  },
  mediaSubtitle: {
    color: colors.white,
    fontFamily: fonts.gothicSemiBold,
    fontSize: 15,
    textAlign: 'center',
    marginBottom: 18,
    maxWidth: 320,
  },
  mediaList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  mediaListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    color: colors.white,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.md,
    marginBottom: 4,
    textAlign: 'center',
  },
  mediaCheckIcon: {
    fontSize: 18,
    color: colors.white,
  },
}));
